module.exports = __webpack_public_path__ + "img/the-netherlands-respiratory-diseases-male.c26fc505.png";